import { render, staticRenderFns } from "./editSpace.vue?vue&type=template&id=6d3493cc&scoped=true&"
import script from "./editSpace.vue?vue&type=script&lang=ts&"
export * from "./editSpace.vue?vue&type=script&lang=ts&"
import style0 from "./editSpace.vue?vue&type=style&index=0&id=6d3493cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3493cc",
  null
  
)

export default component.exports